import React from 'react';
import BusquedaComitenteModificar from '../components/filtroBusquedaComitenteModificar';

const BusquedaComitentesModificar = () => {
    return (
       <BusquedaComitenteModificar />
    );
};

export default BusquedaComitentesModificar;